module.exports = __webpack_public_path__ + "static/media/sba-logo-color.5422bf3b.svg";